module.exports = __webpack_public_path__ + "static/media/arrow-down.94846311.svg";